import { hostApi } from "@/apis/index";
import Vue from 'vue';

const api_booking = `${hostApi}/api/bookings`;

function getBookingList(params)
{
    return Vue.prototype.$http.get(api_booking, { params });
}

function getBooking(id)
{
    return Vue.prototype.$http.get(`${api_booking}/${id}/with`);
}

function createBooking(item)
{
    return Vue.prototype.$http.post(`${api_booking}`, item);
}

function cancelBooking(id) 
{
    return Vue.prototype.$http.post(`${api_booking}/cancel/${id}`);
}

function changeBooking(id) 
{
    return Vue.prototype.$http.post(`${api_booking}/changeOk/${id}`);
}

function updateBooking(item)
{
    return Vue.prototype.$http.put(`${api_booking}/${item.id}`, item);
}

function getBookingAlarmCount(item)
{
    return Vue.prototype.$http.post(`${api_booking}/loginUserAlarmCount`, item);
}



export {
    getBookingList,
    getBooking,
    createBooking,
    cancelBooking,
    changeBooking,
    updateBooking,
    getBookingAlarmCount
};
